import { render, staticRenderFns } from "./PhonePicker.vue?vue&type=template&id=357b79d3&scoped=true"
import script from "./PhonePicker.vue?vue&type=script&lang=ts"
export * from "./PhonePicker.vue?vue&type=script&lang=ts"
import style0 from "./PhonePicker.vue?vue&type=style&index=0&id=357b79d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357b79d3",
  null
  
)

export default component.exports